import React, { useState, useEffect } from "react";
import { Card } from "../../../common";
import { RequestItem } from "./RequestItem";
import { clearSignatoryAddress } from "../../../../store/Company/companySlice";
import { useSelector, useDispatch } from "react-redux";

export const RequestTab = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [requests, setRequests] = useState([]);
  const dispatch = useDispatch();
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    setIsOpen(!isOpen);
  };

  const { userInfo } = useSelector((state) => state.auth);


  useEffect(() => {
    dispatch(clearSignatoryAddress());
    localStorage.removeItem("industryData");
    localStorage.removeItem("financialData");
    localStorage.removeItem("companyData");
    localStorage.removeItem("uploadData");
    localStorage.removeItem("companyAddress");
    localStorage.removeItem("authorizedSignatory");
    localStorage.removeItem("userSelectedCompany");
    localStorage.removeItem("createCompany");

    if (userInfo) {
      const requestData = userInfo.individual[0]?.requestIndividual;
      if (requestData != undefined) {
        let sortedCompanines = [...requestData].sort(
          (p1, p2) => (p1.requestID < p2.requestID) ? 1 : (p1.requestID > p2.requestID) ? -1 : 0);
        setRequests(sortedCompanines);
      }

    }
  }, [userInfo]);

  return (
    <Card classes="w-full md:col-start-1 md:col-end-10">
      <h3 className="text-left text-f24 text-primary font-bold">
        Your Submitted Requests
      </h3>
      <p className="text-left text-f16 text-secondarytwo mb-4">
        Track the status of all your requests, including company access and verifications, in this section.
      </p>
      <div className="flex flex-wrap gap-3">
        <div className="my-6 w-full">
          <div className="grid grid-cols-2 gap-2 bg-white rounded-3xl px-3 py-2 ">
            <div
              className={`text-f12 sm:text-f16 py-2 px-4 cursor-pointer ${activeTab === 1
                ? "bg-header text-primary font-semibold shadow-request rounded"
                : "bg-transparent text-gray-800"
                }`}
              onClick={() => handleTabClick(1)}
            >
              Company Requests
            </div>
          </div>
          <div className="mt-6">
            <div className="px-2 py-4 bg-white rounded-lg">
              <div className="flex justify-between p-3">
                <div className="hidden sm:block text-f12 uppercase text-company font-semibold">
                  Information
                </div>
                <div className="text-f12 uppercase text-company font-semibold">
                  Request Status
                </div>
              </div>
              <hr />
              <div className="divide-y">
                {activeTab === 1 &&
                  requests.map((item) => <RequestItem request={item} />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
